export const ROOT_PAGE = {
  SIDE_NAV: 'root-page-side-nav',
  SIDE_NAV_TOGGLE: 'root-page-side-nav-toggle'
} as const;
